var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isReady)?_c('CalendarEvents',{attrs:{"eventsData":_vm.eventsData,"local-events":_vm.hasLocalEvents}}):_c('span',[_vm._v(_vm._s(_vm.emptyText))])}
var staticRenderFns = []

export { render, staticRenderFns }